import { ca } from '@cian/analytics';

import { IJsonQuery } from 'shared/json_query';

export function trackDealSaleBannerClick(jsonQuery: IJsonQuery, source?: string) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'trap',
    label: 'deal_banner',
    name: 'oldevent',
    page: {
      extra: {
        trap_type: 'deal',
        bannerName: 'Баннера "Циан.Сделка"',
        trapid: 'Баннера "Циан.Сделка"',
        source,
      },
    },
    sc: jsonQuery,
  });
}

export function trackDealSaleBannerShow(jsonQuery: IJsonQuery, source?: string) {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'trap',
    label: 'deal_banner',
    name: 'oldevent',
    page: {
      extra: {
        trap_type: 'deal',
        bannerName: 'Баннера "Циан.Сделка"',
        trapid: 'Баннера "Циан.Сделка"',
        source,
      },
    },
    sc: jsonQuery,
  });
}
